import ApexCharts from 'apexcharts'

var chartInstance = null

export default {
  build (data, options, id) {
    if (chartInstance) chartInstance.destroy()
    this.config(data, options)
    chartInstance = new ApexCharts(document.querySelector(id), this.config(data, options))
    chartInstance.render()
  },
  config (data, options) {
    return {
      chart: {
        height: 350,
        type: 'bar'
      },
      plotOptions: {
        bar: {
          horizontal: false,
          endingShape: 'flat',
          columnWidth: '55%'
        }
      },
      dataLabels: {
        enabled: false
      },
      title: {
        text: '',
        align: 'center'
      },
      stroke: {
        show: true,
        width: 2,
        colors: ['transparent']
      },
      series: data,
      xaxis: {
        categories: options.categories
      },
      fill: {
        opacity: 1

      },
      yaxis: {
        title: {
          text: options.name
        },
        labels: {
          formatter: function (val) {
            if (options.dataType === 'percentage') return val.toFixed(2) + '%'
            if (options.dataType === 'currency') return '$' + val.toFixed(2)
            return val
          }
        }
      },
      tooltip: {
        y: {
          formatter: function (val) {
            if (options.dataType === 'currency') return '$' + val.toFixed(2)
            if (options.dataType === 'percentage') return val.toFixed(2) + '%'
            return val
          }
        }
      }
    }
  }
}
